import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { AppDomService } from './app-dom.service';
import { TranslationKey } from './enums';
import { IModalDialogConfig, IModalDialogResult } from './interfaces';

@Injectable({
    providedIn: 'root'
})
export class ModalDialogService {
    constructor(private readonly appDomSvc: AppDomService, private readonly translateSvc: TranslateService) {
    }

    async showMessageBox(text: string): Promise<void> {
        const dlgConfig: IModalDialogConfig = {
            firstButton: { id: 'ok', text: this.translateSvc.instant(TranslationKey.ok) },
            textLines: [text]
        };
        await this.showPopupDialog(dlgConfig);
        this.hidePopupDialog();
    }

    showPopupDialog(config: IModalDialogConfig): Promise<IModalDialogResult> {
        const modalDialogOverlayEl = document.querySelector('[aza-rws-modal-dialog-overlay]');
        const modalDialogEl = document.querySelector('[aza-rws-modal-dialog]');
        this.appDomSvc.showElementWithCss(modalDialogOverlayEl);
        this.appDomSvc.showElementWithCss(modalDialogEl);

        if (config.title) {
            const modalDialogTitleEl = modalDialogEl.querySelector('[aza-rws-modal-dialog-title]') as HTMLElement;
            modalDialogTitleEl.innerText = config.title;
        }

        const modalDialogTextEl = modalDialogEl.querySelector('[aza-rws-modal-dialog-text]') as HTMLElement;
        modalDialogTextEl.innerText = '';
        for (const line of config.textLines) {
            const divText = document.createElement('div');
            divText.innerText = line;
            divText.classList.add('modal-dialog-text-line');
            modalDialogTextEl.appendChild(divText);
        }

        const firstButtonEl = document.querySelector('[aza-rws-modal-dialog-first-button]') as HTMLElement;
        firstButtonEl.innerText = config.firstButton.text;

        const secondButtonEl = document.querySelector('[aza-rws-modal-dialog-second-button]') as HTMLElement;
        const secondButtonContainerEl = document.querySelector('[aza-rws-modal-dialog-second-button-container]') as HTMLElement;
        if (config.secondButton) {
            secondButtonEl.innerText = config.secondButton.text;
            this.appDomSvc.showElementWithCss(secondButtonContainerEl);
        } else {
            this.appDomSvc.hideElementWithCss(secondButtonContainerEl);
        }

        const thirdButtonEl = document.querySelector('[aza-rws-modal-dialog-third-button]') as HTMLElement;
        const thirdButtonContainerEl = document.querySelector('[aza-rws-modal-dialog-third-button-container]') as HTMLElement;
        if (config.thirdButton) {
            thirdButtonEl.innerText = config.thirdButton.text;
            this.appDomSvc.showElementWithCss(thirdButtonContainerEl);
        } else {
            this.appDomSvc.hideElementWithCss(thirdButtonContainerEl);
        }

        const promise = new Promise<IModalDialogResult>((resolve) => {
            const dlgResult = {} as IModalDialogResult;
            firstButtonEl.onclick = ev => {
                dlgResult.clickedButtonId = config.firstButton.id;
                resolve(dlgResult);
            };
            if (secondButtonEl) {
                secondButtonEl.onclick = ev => {
                    dlgResult.clickedButtonId = config.secondButton.id;
                    resolve(dlgResult);
                };
            }
            if (thirdButtonEl) {
                thirdButtonEl.onclick = ev => {
                    dlgResult.clickedButtonId = config.thirdButton.id;
                    resolve(dlgResult);
                };
            }
        });
        return promise;
    }

    hidePopupDialog(): void {
        const modalDialogOverlayEl = document.querySelector('[aza-rws-modal-dialog-overlay]');
        const modalDialogEl = document.querySelector('[aza-rws-modal-dialog]');
        this.appDomSvc.hideElementWithCss(modalDialogOverlayEl);
        this.appDomSvc.hideElementWithCss(modalDialogEl);
        const modalDialogTextEl = modalDialogEl.querySelector('[aza-rws-modal-dialog-text]') as HTMLElement;
        modalDialogTextEl.innerText = '';
    }
}
